import Page from '../../containers/Page/Page';
import { Button, Card, CardActions, CardContent, CardMedia, Grid, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import { useAuth } from '../../hooks/auth';
import AcessoriosImage from '../../assets/images/home/home_acessorios.jpg';
import BombasImage from '../../assets/images/home/home_bombas.jpg';
import FlangesImage from '../../assets/images/home/home_flanges.jpg';
import ModelosImage from '../../assets/images/home/home_modelos.jpg';
import PropostasImage from '../../assets/images/home/home_propostas.jpg';
import TabelasImage from '../../assets/images/home/home_tabelas.jpg';

function Home() {

    const classes = useStyles();
    const { data } = useAuth();

    return (
        <Page>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Bem vindo, {data.user.nome}!
                </Typography>
            </Page.Title>
            <Grid container className={classes.row} spacing={4}>
                <Grid item md={4} xs={12}>
                    <Card>
                        <CardMedia
                            className={classes.media}
                            image={AcessoriosImage}
                            title="Acessórios"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Acessórios
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                127 acessórios cadastrados
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" color="primary">
                                Novo Acessório
                            </Button>
                            <Button size="small" color="primary">
                                Consultar Acessórios
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                    <Card>
                        <CardMedia
                            className={classes.media}
                            image={BombasImage}
                            title="Bombas"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Bombas
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                52 bombas cadastradas
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" color="primary">
                                Nova Bomba
                            </Button>
                            <Button size="small" color="primary">
                                Consultar Bombas
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                    <Card>
                        <CardMedia
                            className={classes.media}
                            image={FlangesImage}
                            title="Flanges"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Flanges
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                71 flanges cadastradas
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" color="primary">
                                Consultar Flanges
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                    <Card>
                        <CardMedia
                            className={classes.media}
                            image={ModelosImage}
                            title="Modelos"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Modelos
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                120 modelos cadastradas
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" color="primary">
                                Novo Modelo
                            </Button>
                            <Button size="small" color="primary">
                                Consultar Modelos
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                    <Card>
                        <CardMedia
                            className={classes.media}
                            image={PropostasImage}
                            title="Propostas"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Propostas
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                27 propostas cadastradas
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" color="primary">
                                Nova Proposta
                            </Button>
                            <Button size="small" color="primary">
                                Consultar Propostas
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item md={4} xs={12}>
                    <Card>
                        <CardMedia
                            className={classes.media}
                            image={TabelasImage}
                            title="Tabelas de Preços"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Tabelas de Preços
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                97 tabelas cadastradas
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button size="small" color="primary">
                                Nova Tabela
                            </Button>
                            <Button size="small" color="primary">
                                Consultar Tabelas
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </Page>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        row: {
            marginBottom: theme.spacing(2),
        },
        media: {
            height: 200,
        }
    })
);

export default Home;